module.exports = __webpack_public_path__ + "img/ben-smc.e386ecff.jpg";